<template>
    <p class="subheadline">{{ headline }}</p>
    <div v-if="includeRequiredCompany">
        <label for="deliveryAddress-company" class="small">Firma*</label>
        <input id="deliveryAddress-company" class="input" type="text" placeholder="Firma" required
               :value="company"
               @input="$emit('update:company', $event.target.value)">
    </div>
    <Salutation id="deliveryAddress-salutation" :salutation-options="salutationOptions" :salutation="salutation" @update:salutation="salutationChanged"/>
    <div>
        <label for="deliveryAddress-firstName" class="small">Vorname*</label>
        <input id="deliveryAddress-firstName" class="input" type="text" placeholder="Vorname" required
               :value="firstName"
               @input="$emit('update:firstName', $event.target.value)">
    </div>
    <div>
        <label for="deliveryAddress-lastName" class="small">Nachname*</label>
        <input id="deliveryAddress-lastName" class="input" type="text" placeholder="Nachname" required
               :value="lastName"
               @input="$emit('update:lastName', $event.target.value)">
    </div>
    <div>
        <label for="deliveryAddress-street" class="small">Straße und Hausnummer*</label>
        <input id="deliveryAddress-street" class="input" type="text" placeholder="Straße und Hausnummer" required
               :value="street"
                @input="$emit('update:street', $event.target.value)">
    </div>
    <div>
        <label for="deliveryAddress-zipCode" class="small">Postleitzahl*</label>
        <input id="deliveryAddress-zipCode" class="input" :class="{ 'input-error': zipCodeError }" type="text"
               inputmode="numeric" pattern="[0-9]*" placeholder="Postleitzahl" required
               :value="zipCode"
               @input="handleZipCodeInput($event)">
        <span v-if="zipCodeError" class="error-message">Bitte geben Sie eine gültige Postleitzahl ein (nur Zahlen).</span>
    </div>
    <div>
        <label for="deliveryAddress-city" class="small">Ort*</label>
        <input id="deliveryAddress-city" class="input" type="text" placeholder="Ort" required
               :value="city"
               @input="$emit('update:city', $event.target.value)">
    </div>
    <div>
        <label for="deliveryAddress-deliveryInformation" class="small">
            Lieferinformationen wie Stockwerk, Hinterhaus oder Ähnliches
        </label>
        <textarea id="deliveryAddress-deliveryInformation" class="textarea"
                  placeholder="Lieferinformationen wie Stockwerk, Hinterhaus oder Ähnliches"
                  :value="deliveryInfo"
                  @input="$emit('update:deliveryInfo', $event.target.value)"/>
    </div>
    <div>
        <label for="deliveryAddress-phone" class="small">Telefonnummer*</label>
        <input id="deliveryAddress-phone" class="input" type="text" placeholder="Telefonnummer" required
               :value="phone"
               @input="$emit('update:phone', $event.target.value)">
    </div>
    <div>
        <label for="deliveryAddress-email" class="small">Mailadresse*</label>
        <input id="deliveryAddress-email" class="input" type="text" placeholder="Mailadresse" required
               :value="email"
               @input="$emit('update:email', $event.target.value)">
    </div>
    <div v-if="includeDateOfBirth">
        <label for="deliveryAddress-dateOfBirth" class="small">Geburtsdatum<template v-if="dateOfBirthIsRequired">*</template></label>
        <input id="deliveryAddress-dateOfBirth" class="input" type="date" :max="today"
               :required="dateOfBirthIsRequired"
               :value="dateOfBirth"
               @input="$emit('update:dateOfBirth', $event.target.value)">
    </div>

</template>

<script>

import Salutation from '@/views/components/ui/Register/Step1/Form/Part/Salutation'
import {format} from "date-fns";

export default {
    name: 'RegisterFormPartDeliveryAddress',
    components: {
        Salutation
    },
    props: {
        headline: {
            type: String,
            default: 'Lieferanschrift',
        },
        includeRequiredCompany: Boolean,
        includeDateOfBirth: {
            type: Boolean,
            default: false,
        },
        dateOfBirthIsRequired: {
            type: Boolean,
            default: false,
        },
        salutationOptions: Array,
        company: String,
        salutation: String,
        firstName: String,
        lastName: String,
        street: String,
        zipCode: String,
        city: String,
        deliveryInfo: String,
        phone: String,
        email: String,
        dateOfBirth: String,
    },
    data() {
        return {
            zipCodeError: false,
        };
    },
    computed: {
        today() {
            return format(new Date(), 'yyyy-MM-dd')
        },
    },
    methods: {
        salutationChanged(newSalutation) {
            this.$emit('update:salutation', newSalutation);
        },
        handleZipCodeInput(event) {
            const value = event.target.value;
            // Allow only numeric characters
            const numericValue = value.replace(/[^0-9]/g, '');

            // Update the input value to remove non-numeric characters
            if (value !== numericValue) {
                event.target.value = numericValue;
            }

            // Show error if original input contained non-numeric characters
            this.zipCodeError = value !== numericValue && value.length > 0;

            // Clear error after 3 seconds
            if (this.zipCodeError) {
                setTimeout(() => {
                    this.zipCodeError = false;
                }, 3000);
            }

            this.$emit('update:zipCode', numericValue);
        }
    },
    emits: [
        'update:company',
        'update:salutation',
        'update:firstName',
        'update:lastName',
        'update:street',
        'update:info',
        'update:zipCode',
        'update:city',
        'update:deliveryInfo',
        'update:phone',
        'update:email',
        'update:dateOfBirth',
    ],
}
</script>
